/**
 * 常量
 */
var CONSTANT = {};

// 全局颜色值列表
CONSTANT.COLORS = ['#2D8CF0', '#00B0FD', '#00CDE7', '#00E4B9', '#91F389', '#F9F871', '#F9CC71', '#F9B071', '#F99B71', '#F97F71'];
CONSTANT.LOG_TYPES = [{
  label: '支付宝',
  value: 1
}, {
  label: '百度',
  value: 2
}, {
  label: '集点',
  value: 3
}, {
  label: '扫呗支付',
  value: 4
}, {
  label: 'streffy支付',
  value: 5
}, {
  label: '易佰',
  value: 6
}, {
  label: '5i会员',
  value: 7
}, {
  label: '会员',
  value: 8
}, {
  label: '哗啦啦订单中心',
  value: 9
}, {
  label: '第三方-抖音',
  value: 10
}, {
  label: '第三方-微信',
  value: 11
}, {
  label: '斯慧订单',
  value: 12
}, {
  label: '客如云订单',
  value: 13
}, {
  label: '第三方-快手',
  value: 14
}];
CONSTANT.EVENT_TYPES = [{
  label: '提交订单',
  value: 1
}, {
  label: '支付回调',
  value: 2
}, {
  label: '推送订单',
  value: 3
}, {
  label: 'Pos/订单中心回调',
  value: 4
}, {
  label: '取消订单',
  value: 5
}, {
  label: '申请退款',
  value: 6
}, {
  label: '退款回调',
  value: 7
}, {
  label: '会员卡消费',
  value: 8
}, {
  label: '会员卡撤销消费',
  value: 9
}, {
  label: '会员卡储值',
  value: 10
}, {
  label: '更新订单',
  value: 11
}, {
  label: '发劵',
  value: 12
}, {
  label: '劵作废',
  value: 13
}];
CONSTANT.ORDER_STATUS = [{
  label: '待支付',
  value: '10'
}, {
  label: '已支付',
  value: '20'
}, {
  label: '已签到/已预约/已推送pos/三方配送',
  value: '30'
}, {
  label: '门店已接单',
  value: '40'
}, {
  label: '已制作',
  value: '50'
}, {
  label: '已申请退款',
  value: '60'
}, {
  label: '退款已审核',
  value: '65'
}, {
  label: '已取消',
  value: '70'
}, {
  label: '异常',
  value: '80'
}, {
  label: '退款失败',
  value: '81'
}, {
  label: '已部分退款',
  value: '85'
}, {
  label: '已退款',
  value: '90'
}, {
  label: '已完成',
  value: '100'
}, {
  label: '支付失败',
  value: '14'
}];

// ### 客户管理
// 用户来源平台列表
// 用户来源
// 微信 101
// 公众号 001
// 小程序 002
// 微信公众号 101001
// 微信公众号 101002
// 支付宝 102
// 抖音 103
// 快手 104
// 小红书 105
// app  201
CONSTANT.SOURCE_FROM_LIST = [{
  label: '微信',
  value: '101'
}, {
  label: '公众号',
  value: '001'
}, {
  label: '小程序',
  value: '002'
}, {
  label: '微信公众号',
  value: '101001'
}, {
  label: '微信公小程序',
  value: '101002'
}, {
  label: '支付宝',
  value: '102'
}, {
  label: '支付宝小程序',
  value: '102002'
}, {
  label: '抖音',
  value: '103'
}, {
  label: '抖音小程序',
  value: '103002'
}, {
  label: '快手',
  value: '104'
}, {
  label: '快手小程序',
  value: '104002'
}, {
  label: '小红书',
  value: '105'
}, {
  label: '小红书小程序',
  value: '105002'
}, {
  label: 'app',
  value: '201'
}];
// 渠道列表 这里值是字符串 应该是有些接口只接受字符串 所以重新弄了一份枚举
CONSTANT.SOURCE_FROM_LIST2 = [{
  label: '微信小程序',
  value: '1',
  icon: 'icon-weixinxiaochengxu'
}, {
  label: '支付宝小程序',
  value: '2',
  icon: 'icon-zhifubaoxiaochengxu'
}, {
  label: 'Pos',
  value: '3',
  icon: 'icon-POS_1'
}, {
  label: '大屏',
  value: '4',
  icon: 'icon-daping'
}, {
  label: 'PDA',
  value: '5',
  icon: 'icon-PAD_1'
}, {
  label: '抖音小程序',
  value: '6',
  icon: 'icon-douyin'
}, {
  label: '快手小程序',
  value: '7',
  icon: 'icon-kuaishou'
}, {
  label: '抖音会员通',
  value: '8',
  icon: 'icon-youyin_m'
}, {
  label: '美团会员通',
  value: '9',
  icon: 'icon-meituan_m'
}, {
  label: '美团团购配送',
  value: '10',
  icon: 'icon-meituan_m'
}];

// 用户来源列表
CONSTANT.TYPE_FROM_LIST = [{
  label: '线上',
  value: 1
}, {
  label: '线下',
  value: 2
}];

// 国家列表
CONSTANT.COUNTRY_LIST = [{
  label: '中国',
  value: 'China'
}];

// 性别列表
CONSTANT.SEX_LIST = [{
  label: '男',
  value: 1
}, {
  label: '女',
  value: 2
}, {
  label: '未知',
  value: 0
}];

// 渠道列表
// 20240927 申银屏 1.微信小程序 2.支付宝小程序 3Pos 4.大屏 5.Pad 6抖音
CONSTANT.CHANNEL_LIST = [{
  label: '微信小程序',
  value: 1,
  icon: 'icon-weixinxiaochengxu'
}, {
  label: '支付宝小程序',
  value: 2,
  icon: 'icon-zhifubaoxiaochengxu'
}, {
  label: 'POS',
  value: 3,
  icon: 'icon-POS_1'
}, {
  label: '大屏',
  value: 4,
  icon: 'icon-daping'
}, {
  label: 'PAD',
  value: 5,
  icon: 'icon-PAD_1'
}, {
  label: '抖音小程序',
  value: 6,
  icon: 'icon-PAD_1'
}, {
  label: '快手小程序',
  value: 7,
  icon: 'icon-PAD_1'
}, {
  label: '美团',
  value: 10,
  icon: 'icon-PAD_1'
}];
// 消费渠道列表
CONSTANT.SOURCE_ORDER = [{
  label: '点餐订单',
  value: '1',
  icon: '',
  children: [{
    label: '平台支付',
    value: '1.a'
  }, {
    label: '储值本金支付',
    value: '1.b'
  }, {
    label: '储值赠金支付',
    value: '1.c'
  }, {
    label: '积分支付',
    value: '1.d'
  }]
}, {
  label: '储值订单',
  value: '2',
  icon: '',
  children: []
}, {
  label: '券包订单',
  value: '3',
  icon: '',
  children: []
}, {
  label: '积分商城订单',
  value: '4',
  icon: '',
  children: []
}, {
  label: '礼品卡订单',
  value: '5',
  icon: '',
  children: []
}];

// ### 会员卡方案
// 会员卡类型
CONSTANT.CARD_TYPES = [{
  label: '普通',
  value: 1
}, {
  label: '企业',
  value: 2
}];

// 礼品卡类型
CONSTANT.GIFT_CARD_TYPES = [{
  label: '礼金卡',
  value: 1
}];

// 券模板
CONSTANT.COUPON_TYPE_LIST = [{
  type: 1,
  title: '代金券',
  des: '适用于减免优惠',
  icon: 'https://pic.streffy.com/StreffyAdminImage/StreffyMiddleOffice/image/coupon/coupon_type_1.png'
}, {
  type: 2,
  title: '折扣券',
  des: '适用于设置折扣优惠',
  icon: 'https://pic.streffy.com/StreffyAdminImage/StreffyMiddleOffice/image/coupon/coupon_type_2.png'
}, {
  type: 3,
  title: '商品优惠券',
  des: '适用于设置商品的金额减免',
  icon: 'https://pic.streffy.com/StreffyAdminImage/StreffyMiddleOffice/image/coupon/coupon_type_3.png'
}, {
  type: 6,
  title: '商品兑换券',
  des: '适用于设置商品的兑换优惠',
  icon: 'https://pic.streffy.com/StreffyAdminImage/StreffyMiddleOffice/image/coupon/coupon_type_4.png'
}, {
  type: 4,
  title: '商品折扣券',
  des: '适用于设置商品的金额折扣',
  icon: 'https://pic.streffy.com/StreffyAdminImage/StreffyMiddleOffice/image/coupon/coupon_type_5.png'
}, {
  type: 5,
  title: '买赠券',
  des: '适用于设置买赠优惠',
  icon: 'https://pic.streffy.com/StreffyAdminImage/StreffyMiddleOffice/image/coupon/coupon_type_6.png'
}, {
  type: 7,
  title: '次券',
  des: '适用于多次数多次消费',
  icon: 'https://pic.streffy.com/StreffyAdminImage/StreffyMiddleOffice/image/coupon/coupon_type_7.png'
}];

// 券模版标签
CONSTANT.COUPON_TAG_LIST = [{
  label: '过期退',
  value: 1
}, {
  label: '随时退',
  value: 2
}, {
  label: '免预约',
  value: 3
}];

// 券模版业务属性
CONSTANT.COUPON_BIZTYPE_LIST = [{
  label: '门店业务',
  value: 1
}];

// 券模版业务属性
// 业务类型 1、自提，2 堂食，3、外卖 4 外带 5 拼单 6 积分商品订单 7 预售订单
CONSTANT.SCENE_LIST = [{
  label: '自提',
  value: 2
}, {
  label: '堂食',
  value: 1
}, {
  label: '外卖',
  value: 3
}, {
  label: '外带',
  value: 4
}, {
  label: '拼单',
  value: 5
}, {
  label: '积分商品订单',
  value: 6
}, {
  label: '预售',
  value: 7
}];
// 券模版业务属性
CONSTANT.ORDER_SCENE_LIST = [{
  label: '自提',
  value: 2
}, {
  label: '堂食',
  value: 1
}, {
  label: '外卖',
  value: 3
}];

// 券模版 优惠券状态
CONSTANT.COUPON_STATUS_LIST = [{
  label: '可使用',
  value: 1
}, {
  label: '已核销',
  value: 2
}, {
  label: '已过期',
  value: 3
}, {
  label: '已作废',
  value: 4
}, {
  label: '已出售',
  value: 5
}, {
  label: '出售中',
  value: 6
}, {
  label: '转赠中',
  value: 7
}, {
  label: '已转赠',
  value: 8
}, {
  label: '冻结',
  value: 9
}];

// 券模版 投放批次状态
CONSTANT.BATCH_STATUS_LIST = [{
  label: '全部',
  value: 0
}, {
  label: '未开启',
  value: 1
}, {
  label: '进行中',
  value: 2
}, {
  label: '已结束',
  value: 3
}, {
  label: '已失效',
  value: 4
}];

// 券模版 投放批次状态
CONSTANT.BATCH_STATUS_LIST = [{
  label: '全部',
  value: 0
}, {
  label: '未开启',
  value: 1
}, {
  label: '进行中',
  value: 2
}, {
  label: '已结束',
  value: 3
}, {
  label: '已失效',
  value: 4
}];
// 活动级规则状态
CONSTANT.ACTIVITY_RULE_STATUS_LIST = [{
  label: '全部',
  value: 0
}, {
  label: '开启',
  value: 1
}, {
  label: '关闭',
  value: 2
}];

// 全局条件数据
CONSTANT.MEMBER_OPERATOR_LIST = [{
  "key": "1",
  "name": "等于",
  "valueType": 0
}, {
  "key": "2",
  "name": "不等于",
  "valueType": 0
}, {
  "key": "3",
  "name": "大于",
  "valueType": 0
}, {
  "key": "4",
  "name": "小于",
  "valueType": 0
}, {
  "key": "5",
  "name": "大于等于",
  "valueType": 0
}, {
  "key": "6",
  "name": "小于等于",
  "valueType": 0
}, {
  "key": "7",
  "name": "范围",
  "valueType": 0
}, {
  "key": "8",
  "name": "包含",
  "valueType": 0
}, {
  "key": "9",
  "name": "不包含",
  "valueType": 0
}];

// 全局标签数据
CONSTANT.MEMBER_TAG_LIST = [{
  "key": "consumeCount30d",
  "name": "30天消费次数",
  "valueType": 2 // 1字符串 2数字
}, {
  "key": "consumeAmount30d",
  "name": "30天消费金额",
  "valueType": 2
}, {
  "key": "rechargeAmount30d",
  "name": "30天储值金额",
  "valueType": 2
}, {
  "key": "daysSinceLastConsume",
  "name": "距上次消费天数",
  "valueType": 2
}, {
  "key": "dineInConsumeCount30d",
  "name": "堂食消费次数",
  "valueType": 2
}, {
  "key": "takeAwayConsumeCount30d",
  "name": "自提消费次数",
  "valueType": 2
}, {
  "key": "wechatConsumeCount30d",
  "name": "微信消费次数",
  "valueType": 2
}, {
  "key": "balanceAmount",
  "name": "储值余额",
  "valueType": 2
}, {
  "key": "pointsBalance",
  "name": "积分余额",
  "valueType": 2
}, {
  "key": "couponCount",
  "name": "优惠券数量",
  "valueType": 2
}, {
  "key": "registerStoreId",
  "name": "注册门店ID",
  "valueType": 2
}, {
  "key": "consumedStoreIds",
  "name": "消费过的门店",
  "valueType": 1
}, {
  "key": "lastConsumeStoreId",
  "name": "最近消费门店",
  "valueType": 2
}, {
  "key": "MemberName",
  "name": "会员姓名",
  "valueType": 1
}, {
  "key": "Phone",
  "name": "手机号",
  "valueType": 1
}, {
  "key": "gender",
  "name": "性别",
  "valueType": 2
}, {
  "key": "age",
  "name": "年龄",
  "valueType": 2
}, {
  "key": "registerTime",
  "name": "注册时间",
  "valueType": 1
}, {
  "key": "memberLevelName",
  "name": "会员所属等级",
  "valueType": 1
}, {
  "key": "registerSource",
  "name": "注册渠道",
  "valueType": 2
}];

// 标签状态
CONSTANT.TAG_STATUS_LIST = [{
  label: '全部',
  value: -1
}, {
  label: '启用',
  value: 1
}, {
  label: '禁用',
  value: 0
}];
/**
 * 活动券 基础数据
 */
CONSTANT.ACTIVITY_COUPON_BASIC_LIST = [{
  key: "特价",
  typeName: "特价",
  groupType: "促销活动",
  activityTypeId: 1,
  // 类型0:具体券或者活动 1：会员折扣（会员价、特价、权益价），2：促销活动（满减、满折、第二份打折） 3：优惠券（折扣券、代金券、兑换券）
  objectTypeId: 3,
  // 具体类型（传对应括号内数字）  会员折扣（2、会员价、3、特价、4、权益价），促销活动（1、满减、2、满折、7、第二份打折） 优惠券（2、折扣券、1、代金券、6、兑换券）
  slot: "promotionType",
  promotionId: 8003
}, {
  key: "第二份半价",
  typeName: "第二份半价",
  groupType: "促销活动",
  activityTypeId: 2,
  objectTypeId: 7,
  slot: "promotionType",
  promotionId: 7
}, {
  key: "满减",
  typeName: "满减",
  groupType: "促销活动",
  activityTypeId: 2,
  objectTypeId: 1,
  slot: "promotionType",
  promotionId: 1
}, {
  key: "满折",
  typeName: "满折",
  groupType: "促销活动",
  activityTypeId: 2,
  objectTypeId: 2,
  slot: "promotionType",
  promotionId: 2
}, {
  key: "满赠",
  typeName: "满赠",
  groupType: "促销活动",
  activityTypeId: 2,
  objectTypeId: 0,
  slot: "promotionType",
  promotionId: 3
}, {
  key: "加价换购",
  typeName: "加价换购",
  groupType: "促销活动",
  slot: "promotionType",
  activityTypeId: 2,
  objectTypeId: 0,
  promotionId: 5
}, {
  key: "代金券",
  typeName: "代金券",
  groupType: "优惠券",
  slot: "promotionType",
  activityTypeId: 3,
  objectTypeId: 1,
  promotionId: 9001
}, {
  key: "折扣券",
  typeName: "折扣券",
  groupType: "优惠券",
  slot: "promotionType",
  activityTypeId: 3,
  objectTypeId: 2,
  promotionId: 9002
},
// {
//     "key": "买赠券",
//     "typeName": "买赠券",
//     "groupType": "优惠券",
//     "slot": "promotionType"
// },
{
  key: "商品兑换券",
  typeName: "商品兑换券",
  groupType: "优惠券",
  slot: "promotionType",
  activityTypeId: 3,
  objectTypeId: 6,
  promotionId: 9006
}, {
  key: "会员价",
  typeName: "会员价",
  groupType: "权益",
  slot: "promotionType",
  activityTypeId: 1,
  objectTypeId: 2,
  promotionId: 8002
}, {
  key: "权益价",
  typeName: "权益价",
  groupType: "权益",
  slot: "promotionType",
  activityTypeId: 1,
  objectTypeId: 4,
  promotionId: 8004
}];

// 活动级启用状态
CONSTANT.ACTIVITY_STATUS_LIST = [{
  label: '全部',
  value: 0
}, {
  label: '开启',
  value: 1
}, {
  label: '关闭',
  value: 2
}];

// 活动级启用状态
// CONSTANT.ACTIVITY_STATUS_LIST = [
//     { label: '全部', value: 0 },
//     { label: '开启', value: 1 },
//     { label: '关闭', value: 2 }
// ]

// 活动级关系类型
CONSTANT.ACTIVITY_RELATIONSHIP_TYPE_LIST = [{
  label: '全部',
  value: 0
}, {
  label: '组间关系',
  value: 1
}, {
  label: '组内关系',
  value: 2
}];

// 活动级规则类型
CONSTANT.ACTIVITY_RULE_TYPE_LIST = [{
  label: '全部',
  value: -1
}, {
  label: '同享不叠加',
  value: 1
}, {
  label: '同享叠加',
  value: 2
}, {
  label: '互斥',
  value: 0
}];
CONSTANT.WEEK_LIST = [{
  label: '周一',
  value: '1'
}, {
  label: '周二',
  value: '2'
}, {
  label: '周三',
  value: '3'
}, {
  label: '周四',
  value: '4'
}, {
  label: '周五',
  value: '5'
}, {
  label: '周六',
  value: '6'
}, {
  label: '周日',
  value: '0'
}];

// 基本档
// 餐段
CONSTANT.MEAL_PERIOD = [{
  label: '餐段1',
  value: 1
}, {
  label: '餐段2',
  value: 2
}, {
  label: '餐段3',
  value: 3
}, {
  label: '餐段4',
  value: 4
}, {
  label: '餐段5',
  value: 5
}];
// 门店经营状态
CONSTANT.STORE_OPERATIONAL_STATUS = [{
  label: '运营中',
  value: 1
}, {
  label: '装修中',
  value: 2
}, {
  label: '已关闭',
  value: 3
}];
// 门店营业状态
CONSTANT.STORE_OPENING_STATUS = [{
  label: '营业中',
  value: 1
}, {
  label: '休息中',
  value: 2
}, {
  label: '打烊',
  value: 3
}];
// 门店运营模式
CONSTANT.STORE_MEAL_TYPE = [{
  label: '快餐',
  value: 1
}, {
  label: '正餐',
  value: 2
}, {
  label: '中餐',
  value: 4
}, {
  label: '自助餐',
  value: 8
}, {
  label: '其它',
  value: 16
}];
// 门店经营方式
CONSTANT.STORE_TYPE = [{
  label: '直营',
  value: 1
}, {
  label: '加盟',
  value: 2
}, {
  label: '联营',
  value: 3
}];
// 服务闭环的角色权限
CONSTANT.SERVE_PERMISSION = [{
  label: '商品闭环',
  value: 1
}, {
  label: '服务闭环',
  value: 2
}, {
  label: '结束',
  value: 3
}, {
  label: '优惠结账相关',
  value: 4
}];

// 预订 订单状态 状态，10-未到店，20-已到店，30-已取消，40-已完成（开台）
CONSTANT.BOOKING_STATUS = [{
  label: '未到店',
  value: 10
}, {
  label: '已到店',
  value: 20
}, {
  label: '已取消',
  value: 30
}, {
  label: '已完成',
  value: 40
}];
// 预订/排队 订单来源 1、pad, 11、微信小程序，21：支付宝小程序, 31:线下扫码  41:美团
CONSTANT.BOOKING_SOURCE = [{
  label: 'PDA',
  value: 1
}, {
  label: '微信',
  value: 11
}, {
  label: '支付宝',
  value: 21
}, {
  label: '美团',
  value: 41
}, {
  label: '线下扫码',
  value: 31
}];
// 预订--排队 订单状态 状态，10、排队 20、取消排队 30、叫号 40、用餐 50、过号
CONSTANT.QUEUING_STATUS = [{
  label: '排队中',
  value: 10
}, {
  label: '已取消',
  value: 20
}, {
  label: '叫号中',
  value: 30
}, {
  label: '已完成',
  value: 40
}, {
  label: '已过号',
  value: 50
}];

// 菜品类型
CONSTANT.PRODUCT_TYPE = [{
  label: '普通菜',
  value: 1
}, {
  label: '套餐',
  value: 2
}];
// 属性分组类型
CONSTANT.GROUP_TYPE = [
// { label: '规格', value: 1 },
{
  label: '口味',
  value: 2
}, {
  label: '做法',
  value: 3
}, {
  label: '配菜',
  value: 4
}, {
  label: '加料',
  value: 5
}];
// 抖音新增商品规格组 规格
CONSTANT.TIKTOK_GROUP_TYPE = [{
  label: '份',
  value: 1
}, {
  label: '个',
  value: 2
}, {
  label: '盒',
  value: 3
}, {
  label: '根',
  value: 4
}, {
  label: '袋',
  value: 5
}, {
  label: '只',
  value: 6
}, {
  label: '支',
  value: 7
}, {
  label: '件',
  value: 8
}];

// 订单退款原因
CONSTANT.ORDER_REFUND_REASON = [{
  label: '用户信息错误',
  value: 'UserInfoError',
  code: '501'
}, {
  label: '商品已经售完',
  value: 'ProductSoldOut',
  code: '502'
}, {
  label: '商家已经打烊',
  value: 'MerchantClosed',
  code: '503'
}, {
  label: '商家现在太忙',
  value: 'MerchantTooBusy',
  code: '504'
}, {
  label: '超出配送范围',
  value: 'OutOfDeliveryRange',
  code: '505'
}, {
  label: '无骑手接单',
  value: 'NoRiderAccepted',
  code: '506'
}, {
  label: '用户自身原因要求取消',
  value: 'UserRequestedCancel',
  code: '507'
}];

// 订单退款状态
CONSTANT.REFUND_STATUS = [{
  label: '顾客发起退款',
  value: '10',
  statusName: '退款申请中'
}, {
  label: '商家同意退款',
  value: '20',
  statusName: '商家同意退款'
}, {
  label: '商家拒绝退款',
  value: '30',
  statusName: '商家拒绝退款'
}, {
  label: '商家已发起退款',
  value: '40',
  statusName: '商家已发起退款'
}, {
  label: '退款中',
  value: '70',
  statusName: '退款中'
}, {
  label: '退款失败',
  value: '80',
  statusName: '退款失败'
}, {
  label: '已退款成功',
  value: '99',
  statusName: '退款成功'
}];

// 订单退款状态
CONSTANT.FULFILLTYPE_STATUS = [{
  label: '先买单',
  value: 1
}, {
  label: '后约单',
  value: 2
}, {
  label: '立即配送',
  value: 3
}, {
  label: '一品双开',
  value: 4
}];

// 订单退款状态
CONSTANT.ROLETYPE = [{
  label: '所有',
  value: 'ALL'
}, {
  label: '门店',
  value: 'STORE'
}];

// 退单管理-支付状态: 退款已审核、已退款、支付失败、异常
CONSTANT.REFUND_STATUS2 = [{
  label: '退款已审核',
  value: '1'
}, {
  label: '已退款',
  value: '0'
}, {
  label: '支付失败',
  value: '0'
}, {
  label: '异常',
  value: '0'
}];
// 退单管理-退单+申诉状态：0,未提交信息， 11 提交退款申请审核中, 15 审核通过   18 审核拒绝 , 20 已提交申诉   25 申诉通过   28 申诉拒绝
// 退款状态（0,未提交信息， 11 提交退款申请审核中, 15 审核通过  16 退款失败   18 审核拒绝 , 20 已提交申诉   25 申诉通过  26 退款失败   28 申诉拒绝）
CONSTANT.REFUND_APPEAL_STATUS = [{
  label: '无申请',
  value: 0
}, {
  label: '退款申请审核中',
  value: 11
}, {
  label: '退款申请通过',
  value: 15
}, {
  label: '退款失败',
  value: 16
}, {
  label: '退款申请驳回',
  value: 18
}, {
  label: '申诉审核中',
  value: 20
}, {
  label: '申诉申请通过',
  value: 25
}, {
  label: '退款失败',
  value: 26
}, {
  label: '申诉申请驳回',
  value: 28
}];
// 退单管理-审批结果：同意、驳回  0待审批，1为审批通过，2为审批拒绝  需要获取全列表传-1
CONSTANT.REFUND_APPROVE_STATUS = [{
  label: '待审批',
  value: 0
}, {
  label: '同意',
  value: 1
}, {
  label: '同意',
  value: 10
}, {
  label: '同意',
  value: 20
}, {
  label: '驳回',
  value: 2
}];
CONSTANT.REFUND_APPROVE_STATUS_SEARCH = [{
  label: '待审批',
  value: 0
}, {
  label: '同意',
  value: 1
}, {
  label: '驳回',
  value: 2
}];

// 促销类型
CONSTANT.PROTION = [{
  label: '会员价',
  value: 0
}, {
  label: '满减',
  value: 1
}, {
  label: '满折',
  value: 2
}, {
  label: '满赠',
  value: 3
}, {
  label: '特价活动',
  value: 4
}, {
  label: '加价购',
  value: 5
}, {
  label: '随机立减',
  value: 6
}, {
  label: '第二份打折',
  value: 7
}, {
  label: '搭赠',
  value: 8
}];
CONSTANT.Applicable_Users_List = [{
  label: '不限制',
  value: 1
}, {
  label: '仅会员',
  value: 2
}, {
  label: '非会员',
  value: 3
}];

// 券发出/获取方式
CONSTANT.COUPONWAY = [{
  label: '未知',
  value: 0
}, {
  label: '后台',
  value: 1
}, {
  label: '消费送礼',
  value: 2
}, {
  label: '摇奖活动',
  value: 3
}, {
  label: '积分抽奖',
  value: 4
}, {
  label: '免费领取',
  value: 5
}, {
  label: '推荐有礼',
  value: 6
}, {
  label: '储值送礼',
  value: 7
}, {
  label: '开卡礼',
  value: 8
}, {
  label: '生日礼',
  value: 9
}, {
  label: '群发送礼',
  value: 10
}, {
  label: '批量导入',
  value: 11
}, {
  label: '购买权益包',
  value: 12
}, {
  label: '完善资料送礼',
  value: 13
}, {
  label: '升级送礼',
  value: 14
}, {
  label: '累计消费送礼',
  value: 15
}, {
  label: '评价送礼',
  value: 16
}, {
  label: '集点卡',
  value: 17
}, {
  label: '签到',
  value: 18
}, {
  label: '购买券包',
  value: 19
}, {
  label: '转赠',
  value: 20
}, {
  label: '抖音',
  value: 21
}, {
  label: '快手',
  value: 22
}, {
  label: '小红书',
  value: 23
}];

// 启用状态
CONSTANT.OPENTYPE = [{
  label: '全部',
  value: 0
}, {
  label: '启用',
  value: 1
}, {
  label: '禁用',
  value: 2
}];

// 储值活动方案类型
CONSTANT.RECHARGE_SCHEME_TYPE = [{
  label: '固定储值',
  value: 1
}, {
  label: '推荐储值',
  value: 2
}];

// 储值流水类型
CONSTANT.RECHARGE_TYPE = [{
  label: '储值',
  value: 1
}, {
  label: '订单消费',
  value: 2
}, {
  label: '消费退款',
  value: 3
}, {
  label: '冻结',
  value: 4
}, {
  label: '解冻',
  value: 5
}, {
  label: '调账',
  value: 6
}, {
  label: '活动赠余额',
  value: 7
}, {
  label: '储值退款',
  value: 8
}, {
  label: '初始转入',
  value: 9
}];

// 储值流水类型
CONSTANT.POINTS_TYPE = [{
  label: '会员消费',
  value: 1
}, {
  label: '会员退款',
  value: 2
}, {
  label: '等级消费权益',
  value: 3
}, {
  label: '等级升级权益',
  value: 4
}, {
  label: '等级生日权益',
  value: 5
}, {
  label: '等级会员日权益',
  value: 6
}, {
  label: '营销弹屏有礼',
  value: 7
}, {
  label: '调账',
  value: 10
}];

// 支付方式 1、微信小程序，2：支付宝小程序
CONSTANT.PAY_WEY_LIST = [{
  label: '微信',
  value: 1
}, {
  label: '支付宝',
  value: 2
}];

// 积分商城商品类型
CONSTANT.POINTS_PRODUCT_TYPE = [{
  type: 1,
  title: '虚拟商品',
  icon: 'https://pic.streffy.com/StreffyAdminImage/StreffyMiddleOffice/image/pointsMall/product_1.png'
}, {
  type: 2,
  title: '实物/线下商品',
  icon: 'https://pic.streffy.com/StreffyAdminImage/StreffyMiddleOffice/image/pointsMall/product_2.png'
}, {
  type: 3,
  title: 'API对接商品',
  icon: 'https://pic.streffy.com/StreffyAdminImage/StreffyMiddleOffice/image/pointsMall/product_3.png'
}];

// 积分商城商品类型
CONSTANT.POINTS2_PRODUCT_TYPE = {
  1: '虚拟商品',
  2: '实物/线下商品',
  3: 'API对接商品'
};

// 积分商城兑换方式
CONSTANT.POINTS_EXCHANGE_TYPE = {
  1: '积分',
  2: '现金',
  3: '积分/现金'
};

// 积分商城订单状态
CONSTANT.POINTS_ORDER_STATUS = {
  1: '待支付',
  2: '已取消',
  3: '兑换成功',
  4: '已退款'
};

// 订单用户支付记录总支付状态枚举 （谢老板规定的总支付状态与子项支付项状态枚举不一样）
CONSTANT.RECORDS_STATUS_STR = {
  0: '未支付',
  2: '支付中',
  10: '支付成功',
  20: '支付取消',
  30: '支付失败',
  40: '退款成功',
  50: '部分退款',
  60: '退款失败'
};

// 礼品卡 订单状态 1已下单 2已支付 3已兑换 4已取消 5已退款 6支付失败 7部分退款
CONSTANT.GIFTCARD_STATUS_STR = {
  1: '已下单',
  2: '已支付',
  3: '已兑换',
  4: '已取消',
  5: '已退款',
  6: '支付失败',
  7: '部分退款'
};
// 礼品卡 订单状态 1已下单 2已支付 3已兑换 4已取消 5已退款 6支付失败 7部分退款
CONSTANT.GIFTCARD_STATUS_LIST = [{
  label: '已下单',
  value: 1
}, {
  label: '已支付',
  value: 2
}, {
  label: '已兑换',
  value: 3
}, {
  label: '已取消',
  value: 4
}, {
  label: '已退款',
  value: 5
}, {
  label: '支付失败',
  value: 6
}, {
  label: '部分退款',
  value: 7
}];

// 订单用户支付记录子项支付状态枚举 （谢老板规定的总支付状态与子项支付项状态枚举不一样）
CONSTANT.ACTIONS_STATUS_STR = {
  10: '未支付、待支付',
  20: '支付成功',
  30: '支付失败',
  40: '已退款',
  50: '退款失败',
  60: '已支付、核验成功',
  70: '已支付、核验失败'
};

// 商品新增分类 分类类型枚举 classifyTypeList
CONSTANT.CLASSIFY_TYPE = [{
  label: '默认分类',
  value: 1
}, {
  label: '菜单页推荐分类',
  value: 2
}, {
  label: '隐藏分类',
  value: 3
}, {
  label: '结算页推荐加购分类',
  value: 4
}, {
  label: '限时秒杀分类',
  value: 5
}];

// 广告类型
CONSTANT.BANNER_TYPE = [{
  label: '弹窗广告',
  value: 1
}, {
  label: 'banner图',
  value: 2
}, {
  label: '全屏广告',
  value: 3
}, {
  label: '公告',
  value: 4
}];
// 广告状态
CONSTANT.BANNER_STATUA = [{
  label: '草稿',
  value: 1
}, {
  label: '待发布',
  value: 2
}, {
  label: '未开始',
  value: 3
}, {
  label: '进行中',
  value: 4
}, {
  label: '已结束',
  value: 5
}, {
  label: '已作废',
  value: 6
}];
CONSTANT.AD_SCENE_LIST = [{
  label: '自提',
  value: 2
}, {
  label: '堂食',
  value: 1
}, {
  label: '外卖',
  value: 3
}, {
  label: '外带',
  value: 4
}, {
  label: '买单页',
  value: 5
}, {
  label: '会员储值',
  value: 6
}, {
  label: '券包',
  value: 7
}];
// 配送平台 1达达秒送 2美团快送 3蜂鸟配送 4闪送 5京东配送 platformChannel. isAccess 是否已接入平台
CONSTANT.PLATFORM_CHANNEL = [{
  label: '达达秒送',
  value: 1,
  isAccess: true,
  icon: 'dada.jpg'
}, {
  label: '美团快送',
  value: 2,
  isAccess: true,
  icon: 'meituan.webp'
},
// { label: '饿了么', value: 3, isAccess: false, icon: 'elm.webp' },
{
  label: '蜂鸟配送',
  value: 3,
  isAccess: true,
  icon: 'fengniao.png'
}, {
  label: '京东配送',
  value: 4,
  isAccess: true,
  icon: 'jingdong.webp'
}];
// 配送平台 支持配送的物品品类 1食品小吃 2饮料 5其他 13水果生鲜 21蛋糕 29小龙虾/烧烤 51火锅
CONSTANT.PLATFORM_BUSINESS = [{
  label: '食品小吃',
  value: 1
}, {
  label: '饮料',
  value: 2
}, {
  label: '其他',
  value: 5
}, {
  label: '水果生鲜',
  value: 13
}, {
  label: '蛋糕',
  value: 21
}, {
  label: '小龙虾/烧烤',
  value: 29
}, {
  label: '火锅',
  value: 51
}];
CONSTANT.PLATFORM_STORE_STATUS = [{
  label: '门店激活',
  value: 1
}, {
  label: '门店下线',
  value: 2
}];
CONSTANT.PLATFORM_APPROVE_STATUS = [{
  label: '审核通过',
  value: 1
}, {
  label: '审核拒绝',
  value: 2
}, {
  label: '审核中',
  value: 3
}];
// 操作类型，1 下单，2 发单成功，3 发单失败，4 待接单，5 待取货，6 骑士到店，7 配送中，8 已完成，9 已取消，10 已追加待接单，11 妥投异常之物品返回中，12 妥投异常之物品返回完成，13 售后取件单送达门店，14 创建运单失败，15 已退款，16 骑士申请取消
CONSTANT.PLATFORM_BUSINESS_TYPES = [{
  label: '已下单',
  value: 1
}, {
  label: '发单成功',
  value: 2
}, {
  label: '发单失败',
  value: 3
}, {
  label: '待接单',
  value: 4
}, {
  label: '待取货',
  value: 5
}, {
  label: '骑士到店',
  value: 6
}, {
  label: '配送中',
  value: 7
}, {
  label: '已完成',
  value: 8
}, {
  label: '已取消',
  value: 9
}, {
  label: '已追加待接单',
  value: 10
}, {
  label: '发现异常之物品返回中',
  value: 11
}, {
  label: '发现异常之物品返回完成',
  value: 12
}, {
  label: '售后取件单送达门店',
  value: 13
}, {
  label: '创建运单失败',
  value: 14
}, {
  label: '已退款',
  value: 15
}, {
  label: '骑士申请取消',
  value: 16
}];
// 10、商家已接单 20、待骑手接单  30、骑手已接单 40、骑手已到店 50、骑手配送中 60、骑手已送达 70、配送已取消 80、配送转单 90、妥投异常之物品返回中 100、妥投异常之物品返回完成 110、异常订单
CONSTANT.PLATFORM_DELIVERY_STATUS = [{
  label: '支付成功',
  value: 0
}, {
  label: '商家已接单',
  value: 10
}, {
  label: '待骑手接单',
  value: 20
}, {
  label: '骑手已接单',
  value: 30
}, {
  label: '骑手已到店',
  value: 40
}, {
  label: '骑手配送中',
  value: 50
}, {
  label: '骑手已送达',
  value: 60
}, {
  label: '配送已取消',
  value: 70
}, {
  label: '配送转单',
  value: 80
}, {
  label: '妥投异常之物品返回中',
  value: 90
}, {
  label: '妥投异常之物品返回完成',
  value: 100
}, {
  label: '异常订单',
  value: 110
}];
// cancelFrom 订单取消原因的来源，1 表示达达配送员取消，2 表示商家主动取消，3 表示系统或客服取消，0 表示默认值
CONSTANT.PLATFORM_CANCEL_FORM = [{
  label: '达达配送员取消',
  value: 1
}, {
  label: '商家主动取消',
  value: 2
}, {
  label: '系统或客服取消',
  value: 3
}];
// 配送订单退款原因
// 1没有配送员接单 2配送员没来取货 3配送员态度太差 4顾客取消订单 5订单填写错误 34配送员让我取消此单 35配送员不愿上门取货 36我不需要配送了 37配送员以各种理由表示无法完成订单 10000其他
CONSTANT.TRACK_CANCEL_REASON = [{
  label: '没有配送员接单',
  value: 1
}, {
  label: '配送员没来取货',
  value: 2
}, {
  label: '配送员态度太差',
  value: 3
}, {
  label: '顾客取消订单',
  value: 4
}, {
  label: '订单填写错误',
  value: 5
}, {
  label: '配送员让我取消订单',
  value: 34
}, {
  label: '配送员不愿上门取货',
  value: 35
}, {
  label: '我不需要配送了',
  value: 36
}, {
  label: '配送员以各种理由表示无法完成订单',
  value: 37
}, {
  label: '其他',
  value: 10000
}];

// 协议类型 (1:会员协议，2:隐私协议，3:付费卡协议，4:储值协议，5:券包协议，6:礼品卡协议)
CONSTANT.AGREEMENT_TYPE_LIST = [{
  label: '会员协议',
  value: 1
}, {
  label: '隐私协议',
  value: 2
}, {
  label: '付费卡协议',
  value: 3
}, {
  label: '储值协议',
  value: 4
}, {
  label: '券包协议',
  value: 5
}, {
  label: '礼品卡协议',
  value: 6
}];
// 礼品卡流水类型
CONSTANT.GIFTCARD_TYPE = [{
  label: '激活充值',
  value: 1
}, {
  label: '订单消费',
  value: 2
}, {
  label: '消费退款',
  value: 3
}, {
  label: '兑换充值',
  value: 4
}, {
  label: '充值退款',
  value: 8
}, {
  label: '初始转入',
  value: 9
}];
// 礼品卡流水状态
CONSTANT.GIFTCARD_STATUS = [{
  label: '生效',
  value: 1
}, {
  label: '部分退款',
  value: 3
}, {
  label: '全部退款',
  value: 4
}];
export default CONSTANT;